<template>
  <main class="app-content" v-if="agency">
    <aside class="fixed-sidebar">
      <side-bar :agency="agency"></side-bar>
    </aside>
    <div class="project-layout app-content">
      <template>
        <header class="project-header">
          <h1>{{ agency.displayName }}</h1>
        </header>
      </template>
      <div class="container-fluid">
        <router-link
          :to="'/offices?selectedClient=' + queryParams"
          style="margin-top:15px"
          v-if="currentUser && currentUser.role !== 'ROLE_AGENT_USER'"
        >
          <button type="button" v-if="true" class="btn btn-quaternary">
            BACK TO {{ agency.client.title }} OFFICES
          </button>
        </router-link>
        <div class="order-media">
          <vue-form
            :state="formState"
            name="agentCampaignForm"
            @submit.prevent=""
            ref="form"
          >
            <div class="row">
              <div class="col-4 pad-for-submission">
                <div class="form-group">
                  <select class="custom-select" @change="userChange($event)">
                    <option value="null">Select Agent</option>
                    <template v-for="user in users">
                      <option :key="user.id" :value="user.id">{{
                        user.firstName + ' ' + user.lastName
                      }}</option>
                    </template>
                  </select>
                  <label class="label-with-button">Agent</label>
                </div>

                <div
                  class="form-group"
                  v-if="canAccessAudienceFeatures && selectedUserId"
                >
                  <select class="custom-select" v-model="selectedAudience">
                    <option :value="null">Select an audience</option>
                    <template v-for="audience in audiences">
                      <option :value="audience" :key="audience.id">
                        {{ audience.scopeDisplay }} Audience -
                        {{ audience.name }}
                      </option>
                    </template>
                  </select>
                  <label class="label-with-button"
                    >Select Audience (optional)</label
                  >
                </div>

                <div v-show="selectedUserId">
                  <validate class="form-group">
                    <div>
                      <input
                        type="text"
                        class="form-control"
                        name="name"
                        v-model="agentCampaign.name"
                        placeholder=""
                        @change="validateSignifiCreatives"
                        required
                      />
                      <field-messages name="name" show="$dirty && $invalid">
                        <div class="error" slot="required">
                          Agent name is required
                        </div>
                      </field-messages>
                    </div>
                    <label class="small"
                      >For display in all ad creative formats. Manually include
                      if agent not available in the drop down.
                    </label>
                    <label>Agent Name *</label>
                  </validate>
                  <validate class="form-group">
                    <div>
                      <input
                        type="email"
                        class="form-control"
                        name="email"
                        v-model="agentCampaign.email"
                        placeholder="Please enter a valid email"
                        required
                      />
                      <field-messages name="email" show="$dirty && $invalid">
                        <div class="error" slot="required">
                          Agent Email Address is required
                        </div>
                        <div class="error" slot="email">Email is not valid</div>
                      </field-messages>
                    </div>
                    <label class="small"
                      >Not for display in any ad creative, required for platform
                      communications.</label
                    >
                    <label>Agent Email Address *</label>
                  </validate>
                  <validate class="form-group">
                    <div>
                      <input
                        type="text"
                        class="form-control"
                        name="phone"
                        v-model="agentCampaign.phone"
                        placeholder=""
                        @change="phoneChangeFunction"
                        required
                      />
                      <field-messages name="phone" show="$dirty && $invalid">
                        <div class="error" slot="required">
                          Agent Phone Number is required
                        </div>
                      </field-messages>
                    </div>
                    <label class="small"
                      >For display in all ad creative formats. Please note if
                      not pre-populated.</label
                    >
                    <label>Agent Phone Number *</label>
                  </validate>
                  <div class="form-group">
                    <div class="col-4" style="padding:0; margin-top:10px">
                      <logo-upload
                        :logo="agentCampaign.mainImage"
                        name="mainImage"
                        :displayLabel="false"
                        ref="mainImageRef"
                        v-if="renderComponent"
                        v-on:logoupload="mainImageUpdated = true"
                        :showCheckerboard="false"
                      />
                    </div>
                    <div class="error" v-if="mainImageSizeError">
                      Agent Image must be 1MB Max Size
                    </div>
                    <div class="error" v-if="mainImageError">
                      Agent Image is required
                    </div>
                    <label class="small"
                      >REA Standard Headshot .jpg or .png MAX size 1MB</label
                    >
                    <label>Agent Image *</label>
                  </div>

                  <validate class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      name="postcode"
                      v-model="agentCampaign.postcode"
                      @change="postcodeChangedFunction"
                      required
                      max-list-len="4"
                    />
                    <field-messages name="postcode" show="$dirty && $invalid">
                      <div class="error" slot="required">
                        Postcodes is required
                      </div>
                      <div class="error" slot="max-list-len">
                        Maximum 4 Postcodes
                      </div>
                    </field-messages>
                    <label class="small"
                      >To Geotarget your campaign (SEPARATE BY COMMAS I.E 3000,
                      3001)</label
                    >
                    <label>Agent Target Postcodes (1-4) *</label>
                  </validate>
                </div>
              </div>
              <div class="col-4 pad-for-submission">
                <div v-if="selectedUserId">
                  <div class="form-group">
                    <select class="custom-select" v-model="selectedPackage">
                      <option value="null">Select Campaign Package</option>
                      <template v-for="product in packages">
                        <option
                          :value="product"
                          :key="product.id"
                          v-if="product.type == 'agent'"
                          >{{ product.title }}</option
                        >
                      </template>
                    </select>
                    <div class="error" v-if="selectedPackageError">
                      Campaign Package is required
                    </div>
                    <label class="small">Select the required package.</label>
                    <label class="label-with-button">Campaign Package *</label>
                  </div>
                  <template>
                    <div class="form-group">
                      <div class="date-time-picker-container">
                        <DateTimePicker
                          color="#13a3eb"
                          class="mr-sm-2"
                          noLabel
                          formatted="DD MMM YYYY"
                          format="YYYY-MM-DD"
                          autoClose
                          input-size="sm"
                          :min-date="minDate"
                          v-model="agentCampaign.startDate"
                          noButton
                          noClearButton
                          :no-value-to-custom-elem="false"
                          only-date
                          label="Select start date"
                        >
                        </DateTimePicker>
                        <br />
                      </div>
                      <div class="error" v-if="startDateError">
                        Start date is required
                      </div>
                      <label class="small"
                        >Select the date you would like the campaign to
                        start</label
                      >
                      <label>Campaign start Date *</label>
                    </div>
                  </template>

                  <template v-if="selectedPackage">
                    <div
                      class="form-group"
                      v-if="
                        agency.client.clientDisplayConfig
                          .showAgentCampaignListing
                      "
                    >
                      <label class="small"
                        >SHOWING LAST 7 DAYS - START TYPING TO FIND OLDER
                        LISTINGS</label
                      >
                      <multiselect
                        placeholder="Select or start typing"
                        :value="propertyValue"
                        @select="handlePropertySelect"
                        label="title"
                        track-by="id"
                        name="property"
                        id="property"
                        :options="properties"
                        :searchable="true"
                        :loading="propertiesLoading"
                        :internal-search="false"
                        @search-change="searchProperties"
                        :clear-on-select="false"
                      ></multiselect>
                      <label class="label-with-button"
                        >Select listing for campaign</label
                      >
                    </div>
                    <div class="form-group">
                      <div class="row" style="margin-top:10px">
                        <div class="col-12">
                          <multi-file-upload
                            v-on:fileupload="updatePropertyImageList"
                            :showCheckerboard="false"
                          />
                        </div>
                      </div>
                      <div class="error" v-if="propertyImageSizeError">
                        Hero Image must be 1MB Max Size
                      </div>
                      <div class="error" v-if="propertyImageError">
                        Hero Image is required
                      </div>
                      <label class="small"
                        >Display ads will rotate in order of images uploaded.
                        Only the first image uploaded will appear on social.
                        .jpg or .png max size 1mb each. max 4 images</label
                      >
                      <label>Hero Image/s *</label>
                    </div>

                    <div
                      class="form-group"
                      v-if="selectedPackage.videoRequired"
                    >
                      <div class="row">
                        <div class="col-4">
                          <video-upload
                            :video="video"
                            :displayLabel="false"
                            :handleFileChange="handleVideoFileChange"
                            ref="videoRef"
                          />
                        </div>
                      </div>
                      <label
                        >Video<span style="font-size: 12px;"
                          ><br />MP4 Only - Max 1GB</span
                        >
                        <div
                          v-if="videoSizeError"
                          style="color: red;font-size: 12px; margin-top: 8px;"
                        >
                          {{ VIDEO_ERROR_MESSAGES.MAX_SIZE }}
                        </div></label
                      >
                    </div>
                  </template>
                </div>
              </div>
              <div class="col-4 pad-for-submission">
                <div v-if="selectedPackage">
                  <validate
                    class="form-group"
                    v-if="
                      agency.client.clientDisplayConfig.showAgentCampaignAdTitle
                    "
                  >
                    <div>
                      <input
                        type="text"
                        class="form-control"
                        name="adTitle"
                        v-model="agentCampaign.adTitle"
                        placeholder=""
                        required
                        maxlength="35"
                      />
                      <field-messages name="adTitle" show="$dirty && $invalid">
                        <div class="error" slot="required">
                          Ad Title is required
                        </div>
                      </field-messages>
                    </div>
                    <label class="small"
                      >Enter the title or suburb name for display in the ad (35
                      characters including spaces MAX)</label
                    >
                    <label>Ad Title *</label>
                  </validate>

                  <validate
                    class="form-group"
                    v-if="
                      agency.client.clientDisplayConfig.showAgentCampaignLabel
                    "
                  >
                    <select
                      class="custom-select"
                      name="campaignLabel"
                      v-model="agentCampaign.label"
                    >
                      <option value="">Select Label</option>
                      <option value="Sold">Sold</option>
                      <option value="For lease">For lease</option>
                      <option value="Leased">Leased</option>
                      <option value="For Sale">For Sale</option>
                      <option value="Just Listed">Just Listed</option>
                      <option value="Auction">Auction</option>
                      <option value="Coming Soon">Coming Soon</option>
                      <option value="Just Sold">Just Sold</option>
                    </select>
                    <label class="small"
                      >Select the label you wish to add to the creative. This
                      may sit across the hero image</label
                    >
                    <label class="label-with-button">Campaign Label </label>
                  </validate>

                  <validate class="form-group">
                    <div>
                      <textarea
                        class="form-control"
                        name="shortDescription"
                        v-model="agentCampaign.shortDescription"
                        placeholder=""
                        maxlength="120"
                        @change="validateSignifiCreatives"
                      ></textarea>
                    </div>
                    <label class="small"
                      >120 characters (including spaces) MAX</label
                    >
                    <label>Ad Copy</label>
                  </validate>

                  <validate class="form-group">
                    <div>
                      <input
                        type="text"
                        class="form-control"
                        name="destinationUrl"
                        v-model="agentCampaign.destinationUrl"
                        placeholder=""
                        required
                        @keyup="validateDestinationUrl"
                        @change="destinationUrlChangeFunction"
                      />
                      <field-messages
                        name="destinationUrl"
                        show="$dirty && $invalid"
                      >
                        <div class="error" slot="required">
                          Destination URL is required
                        </div>
                      </field-messages>
                    </div>
                    <div class="error" v-if="destinationUrlError">
                      Destination URL must be a valid https url
                    </div>
                    <label class="small">Ad click destination</label>
                    <label>Destination URL *</label>
                  </validate>

                  <div>
                    <div>
                      <label class="bold">Additional Report Recipients</label>
                      <br />
                      <label class="small"
                        >ADD ADDITIONAL RECIPIENTS FOR THE CAMPAIGN
                        REPORTS</label
                      >
                      <br />
                      <div
                        class="mb-1"
                        v-for="(recipient, index) in recipientLists"
                        :key="'recipient' + index"
                      >
                        <validate>
                          <input
                            class="form-control inline no-m-l"
                            type="email"
                            v-model="recipientLists[index]"
                            :name="'recipient' + index"
                            required
                          />
                          <button
                            type="button"
                            class="btn-remove"
                            @click="removeRecipient(index)"
                          >
                            &times;
                          </button>
                          <field-messages
                            :name="'recipient' + index"
                            show="$dirty && $invalid"
                          >
                            <div class="error" slot="required">
                              Email is required otherwise remove this field
                            </div>
                            <div class="error" slot="email">
                              Email is not valid
                            </div>
                          </field-messages>
                        </validate>
                      </div>
                      <div class="space-between">
                        <button
                          class="btn-link mt-1 mb-2"
                          @click="addRecipient"
                        >
                          Add recipient
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="submission-details">
              <div class="form-group">
                <div class="space-between">
                  <div></div>
                  <div>
                    <div class="text-right">
                      Package Fee:
                      <span class="bold" v-if="selectedPackage">{{
                        selectedPackage.packagePrice | formatCurrency
                      }}</span>
                    </div>
                    <div class="text-right bold" v-if="agency.includeGst">
                      GST 10% Tax:
                      <span v-if="selectedPackage">{{
                        (selectedPackage.packagePrice * 0.1) | formatCurrency
                      }}</span>
                    </div>
                    <div class="text-right bold" v-if="selectedPackage">
                      Total <span v-if="agency.includeGst">(incl. GST)</span
                      ><span v-else>(excl. GST)</span>:
                      <span v-if="selectedPackage">{{
                        formatTotalPrice(selectedPackage) | formatCurrency
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="submission-btn-container">
                  <div class="c__btn--container btn-pad-right">
                    <button
                      class="btn btn-quaternary"
                      @click="openCreativeModal"
                      :disabled="!liveCreatives"
                      :class="{disabled: !liveCreatives}"
                    >
                      Preview Ad Creative
                    </button>
                  </div>
                  <div>
                    <div class="c__btn--container">
                      <button
                        class="btn btn-primary"
                        @click="openModal"
                        type="submit"
                        :disabled="disableSubmit"
                      >
                        Confirm and pay
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vue-form>
        </div>
      </div>
      <result-message :errors="errors"></result-message>
      <transition name="modal">
        <order-media-modal
          :campaign="agentCampaign"
          :campaignId="agentCampaignId"
          :agency="agency"
          :_package="selectedPackage"
          :total="selectedPackage.packagePrice * 1.1"
          :start-date="agentCampaign.startDate"
          v-if="showModal"
          @closeModal="closeModal"
          @closeModalAndCleanCampaign="closeModalAndCleanCampaign"
        ></order-media-modal>
      </transition>

      <transition name="modal">
        <creative-modal
          v-if="showCreativeModal"
          :agencyId="this.selectedAgency.id"
          :campaign="this.agentCampaign"
          :closeModal="closeCreativeModal"
          :logoUrl="officeLogoPreviewUrl"
        ></creative-modal>
      </transition>
      <app-modal-progress-bar
        :state="videoUploadProgress.state"
        :progress="videoUploadProgress.progress"
        :label="videoUploadProgress.label"
        :onCancel="onCancelVideoUpload"
        v-if="videoUploadProgress.visible"
      ></app-modal-progress-bar>
    </div>
  </main>
</template>

<script>
import axios from 'axios';
import SideBar from '../SideBar';

import {SwiperOptions} from '../../../configs/Swiper';
import 'swiper/dist/css/swiper.css';
import Multiselect from 'vue-multiselect';

import DateTimePicker from 'vue-ctk-date-time-picker';
import ResultMessage from '../../../helpers/ResultMessage';
import LogoUpload from '../../../helpers/LogoUpload';
import VideoUpload from '../../../helpers/VideoUpload';
import MultiFileUpload from '../../../helpers/MultiFileUpload';

import AgencyService from '../../../services/agencies';
import FileService from '../../../services/files';
import PropertyService from '../../../services/properties';

import OrderMediaModal from '../OrderMediaModal';
import CreativeModal from '../CreativeModal';
import UserServices from '../../../services/users';
import CampaignServices from '../../../services/campaigns';
import {refreshPageMixin} from '../../../mixins/refreshPage';
import Navigation from '../../../configs/Perimeters/navigation';
import AudienceServiceV2 from '../../../services/V2/AudienceServiceV2';
import {VIDEO_ERROR_MESSAGES, VIDEO_LIMITS} from '../../../configs/videoLimits';
import CampaignServiceV2 from '../../../services/V2/CampaignServiceV2';
import AppModalProgressBar from '../../AppComponents/Loaders/AppModalProgressBar.vue';

export default {
  mixins: [refreshPageMixin],
  components: {
    SideBar,
    ResultMessage,
    OrderMediaModal,
    DateTimePicker,
    LogoUpload,
    VideoUpload,
    CreativeModal,
    MultiFileUpload,
    Multiselect,
    AppModalProgressBar,
  },
  data() {
    return {
      agency: null,
      minDate: null,
      swiperOption: SwiperOptions,
      agentCampaignId: null,
      showModal: false,
      agencyPackages: null,
      clientPackages: null,
      packages: null,
      users: null,
      agentCampaign: {
        type: 'agent',
        name: '',
        email: '',
        phone: '',
        additionalRecipients: '',
        adTitle: '',
        label: '',
        videoUrl: '',
      },
      destinationUrlError: false,
      propertyImageError: false,
      propertyImageSizeError: false,
      mainImageError: false,
      mainImageSizeError: false,
      videoError: false,
      videoUrlError: false,
      selectedPackage: null,
      selectedPackageError: false,
      startDateError: false,
      selectedAgency: null,
      errors: {
        type: Object | Error,
        $clean: true,
      },
      formState: {},
      renderComponent: true,
      mainImageUpdated: false,
      propertyImageTempLocation: '',
      mainImageTempLocation: '',
      liveCreatives: false,
      showCreativeModal: false,
      propertyImageList: [],
      propertyImageTempLocations: [],
      selectedProperty: null,
      properties: [],
      propertiesLoading: false,
      propertySearchTimeout: null,
      selectedUserId: null,
      phoneChanged: false,
      destinationUrlChanged: false,
      mainImageManuallyUpdated: false,
      postcodeChanged: false,
      recipientLists: [],
      disableSubmit: false,
      audiences: [],
      selectedAudience: null,
      video: null,
      videoSizeError: false,
      videoFileTypeError: false,
      VIDEO_ERROR_MESSAGES: VIDEO_ERROR_MESSAGES,
      VIDEO_LIMITS: VIDEO_LIMITS,
      videoUploadProgress: {
        progress: 0,
        visible: false,
        label: 'Uploading your video, please wait...',
        state: 'loading',
      },
      videoUploadController: null,
    };
  },
  methods: {
    formatTotalPrice(selectedPackage) {
      const price = this.agency.includeGst
        ? selectedPackage.packagePrice * 1.1
        : selectedPackage.packagePrice;
      return price;
    },
    phoneChangeFunction() {
      this.phoneChanged = true;
      this.validateSignifiCreatives();
    },
    destinationUrlChangeFunction() {
      this.destinationUrlChanged = true;
      this.validateSignifiCreatives();
    },
    postcodeChangedFunction() {
      this.postcodeChanged = true;
    },
    refresh() {},
    updateMinDate() {
      let today = new Date();
      this.minDate = new Date();
      this.minDate.setDate(today.getDate() + 1);
      let dd = String(this.minDate.getDate()).padStart(2, '0');
      let mm = String(this.minDate.getMonth() + 1).padStart(2, '0');
      let yyyy = this.minDate.getFullYear();
      this.minDate = yyyy + '-' + mm + '-' + dd;
      this.validateSignifiCreatives();
    },
    userChange(event) {
      this.selectedUserId = event.target.value;
      let user = this.users.find((user) => user.id == event.target.value);
      this.agentCampaign.name = user.firstName + ' ' + user.lastName;
      this.agentCampaign.email = user.email;
      this.agentCampaign.phone = user.mobile;
      this.agentCampaign.mainImage = user.imageOriginal;
      this.agentCampaign.postcode = user.postcode;
      if (user.imageOriginal) {
        this.agentCampaign.mainImageTempLocation = '';
        this.$refs.mainImageRef.newLogo = null;
        this.$refs.mainImageRef.uploadFile.size = 1;
      }
      this.uploadTemporaryFile();
      this.formState.name.$dirty = true;
      this.formState.email.$dirty = true;
      this.formState.phone.$dirty = true;
      this.validateSignifiCreatives();
    },
    validateDestinationUrl() {
      if (
        typeof this.agentCampaign.destinationUrl != 'undefined' &&
        this.agentCampaign.destinationUrl !== '' &&
        this.agentCampaign.destinationUrl.substring(0, 5) !== 'https'
      ) {
        this.destinationUrlError = true;
      } else {
        const blockedDomains = [
          'realestate.com.au',
          'domain.com.au',
          'homely.com.au',
          'ratemyagent.com.au',
          'propertymate.com.au',
        ];

        const urlLower = this.agentCampaign.destinationUrl.toLowerCase();
        for (const domain of blockedDomains) {
          if (
            urlLower.includes(`.${domain}`) ||
            urlLower.includes(`https://${domain}`) ||
            urlLower.includes(`https://www.${domain}`)
          ) {
            this.destinationUrlError = true;
            return false;
          }
        }
        this.destinationUrlError = false;
      }
    },
    validatePropertyImage() {
      if (
        !this.$refs.propertyImageRef ||
        typeof this.$refs.propertyImageRef.uploadFile.size === 'undefined'
      ) {
        this.propertyImageError = true;
      } else {
        this.propertyImageError = false;
        if (this.$refs.propertyImageRef.uploadFile.size > 1024000) {
          this.propertyImageSizeError = true;
        } else {
          this.propertyImageSizeError = false;
        }
      }
    },
    validatePropertyImages() {
      this.propertyImageError = false;
      this.propertyImageSizeError = false;
      if (this.propertyImageList.length > 0) {
        this.propertyImageList.forEach((image) => {
          if (typeof image.size === 'undefined') {
            this.propertyImageError = true;
          }
          if (image.size > 1024000) {
            this.propertyImageSizeError = true;
          }
        });
      } else {
        this.propertyImageError = true;
      }
    },
    validateMainImage() {
      if (
        this.agentCampaign.mainImage &&
        (!this.$refs.mainImageRef || !this.$refs.mainImageRef.newLogo)
      ) {
        // Image provided against agent selection
        this.mainImageError = false;
      } else if (
        !this.$refs.mainImageRef ||
        typeof this.$refs.mainImageRef.uploadFile.size === 'undefined'
      ) {
        // No image provided
        this.mainImageError = true;
      } else {
        // Image uploaded against agent image field
        this.mainImageError = false;
        if (this.$refs.mainImageRef.uploadFile.size > 1024000) {
          this.mainImageSizeError = true;
        } else {
          this.mainImageSizeError = false;
        }
      }
    },
    validateVideo() {
      // Reset all video errors
      this.videoError = false;
      this.videoUrlError = false;

      // Check if video is required
      if (!this.selectedPackage || !this.selectedPackage.videoRequired) {
        return;
      }

      // Handle URL-based video
      if (
        !this.agentCampaign.videoUrl ||
        this.agentCampaign.videoUrl.trim() === ''
      ) {
        this.videoError = true;
        return;
      }

      // Validate video URL format
      if (!this.isValidUrl(this.agentCampaign.videoUrl)) {
        this.videoUrlError = true;
        return;
      }
    },
    validateVideoFile() {
      let hasError = false;
      // Reset all video errors
      this.videoSizeError = false;
      this.videoFileTypeError = false;

      // Check if video is required
      if (!this.selectedPackage || !this.selectedPackage.videoRequired) {
        return true;
      }

      // Check if it's a File instance
      if (this.video instanceof File) {
        // Check file size
        if (this.video.size > VIDEO_LIMITS.MAX_SIZE) {
          hasError = true;
          this.videoSizeError = true;
        }

        // Check file type
        const isValidType =
          this.video.type === 'video/mp4' &&
          this.video.name.toLowerCase().endsWith('.mp4');

        if (!isValidType) {
          hasError = true;
          this.videoFileTypeError = true;
        }

        return !hasError;
      }

      return true;
    },
    isValidUrl(string) {
      return string.toLowerCase().startsWith('https://');
    },
    validatePackage() {
      if (!this.selectedPackage) {
        this.selectedPackageError = true;
      } else {
        this.selectedPackageError = false;
      }
    },
    validateStartDate() {
      if (!this.agentCampaign.startDate) {
        this.startDateError = true;
      } else {
        this.startDateError = false;
      }
    },
    validate() {
      this.validateDestinationUrl();
      this.validatePropertyImages();
      this.validateMainImage();
      this.validateVideo();
      this.validatePackage();
      this.validateStartDate();

      if (
        this.destinationUrlError ||
        this.propertyImageError ||
        this.propertyImageSizeError ||
        this.mainImageError ||
        this.mainImageSizeError ||
        this.selectedPackageError ||
        this.startDateError
      ) {
        return false;
      }

      return true;
    },
    async openModal() {
      if (!this.validate() || this.formState.$invalid) {
        // Mark any fields as dirty that might not have been touched so that errors appear
        this.formState.$error
          ? Object.entries(this.formState.$error).forEach((entry) => {
              entry[1].$dirty = true;
            })
          : null;
        return;
      }

      event.preventDefault();
      this.disableSubmit = true;

      this.agentCampaign.package = this.selectedPackage.id;
      this.agentCampaign.agency = this.selectedAgency.id;
      this.agentCampaign.audience = this.selectedAudience
        ? this.selectedAudience.id
        : null;
      this.agentCampaign.additionalRecipients = this.recipientLists.toString();
      if (this.selectedAgency.agentCampaignPaymentOption) {
        this.agentCampaign.paymentOption = this.selectedAgency.agentCampaignPaymentOption;
      } else {
        this.agentCampaign.paymentOption = this.selectedAgency.client.agentCampaignPaymentOption;
      }

      if (
        this.agentCampaign.mainImage &&
        typeof this.agentCampaign.mainImage !== 'undefined' &&
        (!this.$refs.mainImageRef || !this.$refs.mainImageRef.newLogo)
      ) {
        // Send existing mainImage ID
        this.agentCampaign.mainImage = this.agentCampaign.mainImage.id;
      } else if (
        this.$refs.mainImageRef &&
        typeof this.$refs.mainImageRef.uploadFile.size !== 'undefined'
      ) {
        let formData = new FormData();
        formData.append('image', this.$refs.mainImageRef.uploadFile);
        formData.append('subType', 'agent-image');
        await FileService.uploadFile(formData)
          .then((image) => {
            this.agentCampaign.mainImage = image.id;
          })
          .catch((errors) => {
            this.errors = errors;
            return;
          });
      }
      if (!this.errors.$clean) {
        this.disableSubmit = false;
        return;
      }
      // property-image
      if (this.propertyImageList.length > 0) {
        this.agentCampaign.images = [];
        for (let i = 0; i < this.propertyImageList.length; i++) {
          let formData = new FormData();
          formData.append('image', this.propertyImageList[i].file);
          formData.append('subType', 'property-image');
          await FileService.uploadFile(formData)
            .then((image) => {
              this.agentCampaign.images.push(image.id);
            })
            .catch((errors) => {
              this.errors = errors;
              return;
            });
        }
      }
      if (!this.errors.$clean) {
        this.disableSubmit = false;
        return;
      }

      await CampaignServices.createCampaign(this.agentCampaign)
        .then((agentCampaign) => {
          if (agentCampaign && agentCampaign.id) {
            this.agentCampaignId = agentCampaign.id;
            this.agentCampaign.mainImage = agentCampaign.mainImage;
          }
        })
        .catch((errors) => {
          this.errors = errors;
          return;
        });
      if (!this.errors.$clean) {
        this.disableSubmit = false;
        return;
      }

      // Update Agent user phone and image
      if (this.selectedUserId && this.selectedUserId != 'null') {
        this.userUpdate();
      }

      await this.uploadVideo(this.agentCampaignId);
      if (!this.errors.$clean) {
        this.disableSubmit = false;
        return;
      }
      this.showModal = true;
    },
    async uploadVideo(campaignId) {
      // Handle URL-based video upload
      if (this.agentCampaign.videoUrl) {
        await CampaignServices.uploadVideoViaUrl(
          campaignId,
          this.agentCampaign.videoUrl
        ).catch((errors) => {
          this.errors = errors;
          return;
        });
      }
    },
    closeModal() {
      this.showModal = false;
      this.disableSubmit = false;
    },
    closeModalAndCleanCampaign() {
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
        this.agentCampaign = {
          type: 'agent',
        };
        this.selectedPackage = null;
        this.$refs.form.reset();
      });
      this.showModal = false;
      this.disableSubmit = false;
    },
    getAgency() {
      AgencyService.getAgency(
        this.$route.params.agency,
        'address,automateReport,client,permissions,ordersReport'
      ).then((agency) => {
        this.agency = agency;
        this.selectedAgency = agency;
        this.agencyPackages = agency.packages ? agency.packages.data : [];
        this.clientPackages = agency.client.packages
          ? agency.client.packages.data
          : [];
        this.packages = [...this.agencyPackages, ...this.clientPackages];
        this.packages = Array.from(new Set(this.packages.map((a) => a.id))).map(
          (id) => {
            return this.packages.find((a) => a.id === id);
          }
        );
        this.packages = this.packages.filter(
          (pack) => pack.status == 'published'
        );
        this.packages.sort((a, b) =>
          a.sortOrder > b.sortOrder ? 1 : b.sortOrder > a.sortOrder ? -1 : 0
        );
        this.users = agency.permissions
          ? agency.permissions.data.map((a) => a.user)
          : [];
        agency.client.clientAdmins
          ? (this.users = this.users.concat(agency.client.clientAdmins.data))
          : null;
        this.users.sort((a, b) =>
          a.firstName.toLowerCase() + a.lastName.toLowerCase() >
          b.firstName.toLowerCase() + b.lastName.toLowerCase()
            ? 1
            : b.firstName.toLowerCase() + b.lastName.toLowerCase() >
              a.firstName.toLowerCase() + a.lastName.toLowerCase()
            ? -1
            : 0
        );
        this.getProperties();
      });
    },
    getProperties() {
      PropertyService.setAgency(this.selectedAgency)
        .getProperties('', 'mainImage,slug')
        .then((properties) => {
          this.properties = properties.data;
        });
    },
    searchProperties(query) {
      clearTimeout(this.propertySearchTimeout);
      this.propertySearchTimeout = setTimeout(() => {
        if (query) {
          this.propertiesLoading = true;
          PropertyService.setAgency(this.selectedAgency)
            .getProperties('', 'mainImage,slug', query)
            .then((properties) => {
              this.properties = properties.data;
              this.propertiesLoading = false;
            })
            .catch((error) => {
              this.propertiesLoading = false;
            });
        } else if (!this.selectedProperty) {
          this.getProperties();
        }
      }, 1000);
    },
    handlePropertySelect(data) {
      this.selectedProperty = data;
      PropertyService.getProperty(data.id, 'images,propertyUsers').then(
        (property) => {
          this.selectedProperty = property;
        }
      );
      this.agentCampaign.property = data.id;
    },
    validateSignifiCreatives() {
      if (
        typeof this.agentCampaign.phone == 'undefined' ||
        this.agentCampaign.phone == ''
      ) {
        this.liveCreatives = false;
        return;
      }
      if (
        typeof this.agentCampaign.name == 'undefined' ||
        this.agentCampaign.name == ''
      ) {
        this.liveCreatives = false;
        return;
      }
      if (
        typeof this.propertyImageTempLocations == 'undefined' ||
        this.propertyImageTempLocations.length == 0
      ) {
        this.liveCreatives = false;
        return;
      }
      if (
        typeof this.agentCampaign.mainImage == 'undefined' ||
        this.agentCampaign.mainImage == ''
      ) {
        if (
          typeof this.mainImageTempLocation == 'undefined' ||
          this.mainImageTempLocation == ''
        ) {
          this.liveCreatives = false;
          return;
        }
      }
      if (
        typeof this.mainImageTempLocation != 'undefined' &&
        this.mainImageTempLocation != ''
      ) {
        this.agentCampaign.mainImageTempLocation = this.mainImageTempLocation;
      }
      this.agentCampaign.propertyImageTempLocations = this.propertyImageTempLocations;
      this.liveCreatives = true;
    },
    uploadTemporaryFile() {
      let formData = null;
      formData = new FormData();
      let imageType = null;
      if (this.mainImageUpdated) {
        if (
          this.$refs.mainImageRef &&
          typeof this.$refs.mainImageRef.uploadFile.size !== 'undefined'
        ) {
          formData.append('image', this.$refs.mainImageRef.uploadFile);
        }
        this.mainImageUpdated = false;
        this.mainImageManuallyUpdated = true;
        imageType = 'agent';
      }
      if (imageType) {
        FileService.uploadTempFile(formData)
          .then((response) => {
            if (imageType == 'agent') {
              this.mainImageTempLocation = response;
            }
            this.validateSignifiCreatives();
          })
          .catch((errors) => {});
      }
    },
    openCreativeModal() {
      if (this.liveCreatives) {
        this.showCreativeModal = true;
      }
    },
    closeCreativeModal() {
      this.showCreativeModal = false;
    },
    updatePropertyImageList(propertyImageList) {
      let formData = new FormData();
      this.propertyImageList = propertyImageList;
      if (this.propertyImageList.length > 0) {
        for (let i = 0; i < this.propertyImageList.length; i++) {
          formData.append('images[]', this.propertyImageList[i].file);
        }
      }
      FileService.uploadMultipleTempFiles(formData)
        .then((response) => {
          this.propertyImageTempLocations = JSON.parse(response);
          this.validateSignifiCreatives();
          this.validatePropertyImages();
        })
        .catch((errors) => {});
    },
    async userUpdate() {
      if (
        this.phoneChanged ||
        this.mainImageManuallyUpdated ||
        this.destinationUrlChanged ||
        this.postcodeChanged
      ) {
        const user = this.users.find((findUser) => {
          return findUser.id == this.selectedUserId;
        });

        if (!user) {
          return;
        }

        if (this.phoneChanged) {
          user.mobile = this.agentCampaign.phone;
        }

        if (this.destinationUrlChanged) {
          user.destinationUrl = this.agentCampaign.destinationUrl;
        }

        if (this.postcodeChanged) {
          user.postcode = this.agentCampaign.postcode;
        }

        if (this.mainImageManuallyUpdated) {
          let formData = null;
          if (
            this.$refs.mainImageRef &&
            typeof this.$refs.mainImageRef.uploadFile.size !== 'undefined'
          ) {
            formData = new FormData();
            formData.append('image', this.$refs.mainImageRef.uploadFile);
            formData.append('subType', 'agent original');
          }

          if (formData) {
            await FileService.uploadFile(formData)
              .then((mainImageRef) => {
                user.imageOriginal = mainImageRef.id;
              })
              .catch((errors) => {
                this.errors = errors;
              });
          }
        } else if (user.imageOriginal) {
          user.imageOriginal = user.imageOriginal.id;
        }

        user.role = user.role.value;

        UserServices.updateUser(user);
      }
    },
    addRecipient() {
      this.recipientLists.push('');
    },
    removeRecipient(index) {
      this.recipientLists.splice(index, 1);
    },
    onCancelVideoUpload() {
      // Cancel the ongoing API request
      if (this.videoUploadController) {
        this.videoUploadController.abort();
        this.videoUploadController = null;
      }
      this.videoUploadProgress.visible = false;
      this.videoUploadProgress.progress = 0;
      this.videoUploadProgress.state = 'loading';
      this.videoUploadProgress.label = 'Uploading your video, please wait...';
      this.video = null;
      this.agentCampaign.videoId = null;
      if (this.$refs.videoRef) {
        this.$refs.videoRef.clearVideo();
      }
    },
    async handleVideoFileChange(file) {
      // Clear any existing controller first
      if (this.videoUploadController) {
        this.videoUploadController.abort();
        this.videoUploadController = null;
      }

      this.videoUploadController = new AbortController();

      this.video = file;
      const isValid = this.validateVideoFile();

      if (!isValid) {
        this.videoUploadController = null;
        return;
      }

      this.videoError = false;
      this.videoSizeError = false;
      this.videoFileTypeError = false;
      this.videoUploadProgress.visible = true;
      this.videoUploadProgress.state = 'loading';
      this.videoUploadProgress.progress = 0;
      this.videoUploadProgress.label = 'Uploading your video, please wait...';

      try {
        const presignedData = await CampaignServiceV2.getUploadPresignedUrl(
          file.name
        );

        const onProgress = (progress) => {
          if (progress < 95) {
            this.videoUploadProgress.progress = progress;
          }
        };

        await CampaignServiceV2.uploadBinaryToPresignedUrl(
          presignedData.data.url,
          file,
          onProgress,
          this.videoUploadController
        );

        const registeredVideo = await CampaignServiceV2.registerVideo({
          filename: presignedData.data.filename,
        });

        this.agentCampaign.videoId = registeredVideo.data.id;
        this.videoError = false;

        this.videoUploadProgress.progress = 100;
        this.videoUploadProgress.state = 'loaded';
        this.videoUploadProgress.label = 'Video upload successful.';
      } catch (error) {
        // Handle abort specifically - for axios 0.18.0 cancellation
        if (
          error.name === 'AbortError' ||
          error.message.includes('aborted') ||
          error.code === 'ERR_CANCELED' ||
          axios.isCancel(error) ||
          error.message.includes('cancelled') ||
          error.message === 'Upload cancelled by user'
        ) {
          this.videoUploadProgress.state = 'cancelled';
          this.videoUploadProgress.label = 'Video upload cancelled.';
          // Don't clear video on cancel, just hide progress
          setTimeout(() => {
            this.videoUploadProgress.visible = false;
          }, 1000);
          return;
        }

        // Handle other errors
        this.video = null;
        this.agentCampaign.videoId = null;
        if (this.$refs.videoRef) {
          this.$refs.videoRef.clearVideo();
        }
        this.videoUploadProgress.state = 'error';
        this.videoUploadProgress.label =
          'Video upload failed. Please try again.';
        setTimeout(() => {
          if (this.$refs.videoRef) {
            this.$refs.videoRef.clearVideo();
          }
        }, 2000);
      } finally {
        // Clean up the controller
        if (this.videoUploadController) {
          this.videoUploadController = null;
        }

        // Hide progress bar after delay (unless it was cancelled, which handles its own timeout)
        setTimeout(() => {
          if (this.videoUploadProgress.state !== 'cancelled') {
            this.videoUploadProgress.visible = false;
          }
        }, 2000);
      }
    },
  },
  computed: {
    propertyValue() {
      return this.properties
        ? this.properties.find((property) => {
            if (this.selectedProperty) {
              return property.id === this.selectedProperty.id;
            }
          })
        : null;
    },
    canAccessAudienceFeatures() {
      return (
        Navigation.isAllowed('accessAudienceFeatures') ||
        Navigation.isAdmin() ||
        Navigation.isSuperAdmin()
      );
    },
    queryParams() {
      return JSON.stringify({
        id: this.agency.client.id,
        title: this.agency.client.title,
      });
    },
    watchedAudienceValue() {
      let agencyId = null;
      if (this.agency && this.agency.id) {
        agencyId = this.agency.id;
      }

      return {
        agentId: this.selectedUserId,
        agencyId,
      };
    },
    officeLogoPreviewUrl() {
      if (
        !this.agency ||
        !this.agency.imageLogo ||
        !this.agency.imageLogo.location
      ) {
        return null;
      }

      return process.env.VUE_APP_CDN_URL + this.agency.imageLogo.location;
    },
  },
  mounted() {
    this.updateMinDate();
    this.getAgency();
    this.currentUser = this.$store.getters.getUser;
  },
  watch: {
    mainImageUpdated: {
      handler: function(val) {
        if (
          val &&
          this.$refs.mainImageRef &&
          typeof this.$refs.mainImageRef.uploadFile.size !== 'undefined'
        ) {
          this.uploadTemporaryFile();
        }
      },
    },
    hashChanged(newVal) {
      if (newVal) {
        this.updateMinDate();
        this.getAgency();
        this.currentUser = this.$store.getters.getUser;
      }
    },

    watchedAudienceValue: {
      handler: function(value) {
        if (Object.values(value).every((val) => !val)) return;
        if (!this.canAccessAudienceFeatures) return;

        AudienceServiceV2.getScopedAudiences(value).then((response) => {
          const data = response.data.data;

          this.audiences = data || [];

          if (this.selectedAudience) {
            const selectedAudienceExists = this.audiences.find(
              (audience) => audience.id === this.selectedAudience.id
            );

            if (!selectedAudienceExists) {
              this.selectedAudience = null;
            }
          }
        });
      },
    },
  },
};
</script>

<style lang="css" scoped>
.order-media {
    position: relative;
}

.submission-details {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding-right: 30px;
}

.submission-btn-container {
    display: flex;
    justify-content: flex-end;
}

.btn-pad-right {
    padding-right: 25px;
}

.pad-for-submission {
    padding-bottom: 150px;
}
</style>
